module.exports = __webpack_public_path__ + "img/45.3ce4286c.png";